import { ref as r, onBeforeUnmount as p } from "vue";
const d = (a, s) => {
  const o = r(!1), t = r(), u = () => {
    s("focus");
  }, f = (e) => {
    var n;
    ((n = e.detail) == null ? void 0 : n.focusReason) !== "pointer" && (t.value = "first", s("blur"));
  }, l = (e) => {
    a.visible && !o.value && (e.target && (t.value = e.target), o.value = !0);
  }, c = (e) => {
    a.trapping || (e.detail.focusReason === "pointer" && e.preventDefault(), o.value = !1);
  }, i = () => {
    o.value = !1, s("close");
  };
  return p(() => {
    t.value = void 0;
  }), {
    focusStartRef: t,
    trapped: o,
    onFocusAfterReleased: f,
    onFocusAfterTrapped: u,
    onFocusInTrap: l,
    onFocusoutPrevented: c,
    onReleaseRequested: i
  };
};
export {
  d as usePopperContentFocusTrap
};
